import { HasId } from '../../../../shared/basic-data-management/has-id.interface';
import { LocalDateTime } from '../../../../shared/jsr310-localdates/types/local-date-time.type';

export class AccesOperationTLR implements HasId {
	id!: number;
	accesId!: number;
	ouvrageId!: number;
	codeCarl!: string;
	boxLocation!: string;
	descriptionOperation!: string;
	acteOnmId!: number;
	etat!: string;
	dateDebut!: LocalDateTime;
	dateFin!: LocalDateTime | null;
	createdByAurora!: boolean;
	numero!: string;
	sequence!: number;

	constructor() {
	}
}